import React from 'react';

const SpeakerTopics = ({ topics, max = 3, onClickTopic, variant = 'chips' }) => {
  if (!topics || topics.length === 0) return null;

  const visible = topics.slice(0, max);
  const remaining = topics.length - max;

  if (variant === 'grid') {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {topics.map((topic, i) => (
          <div
            key={i}
            className="flex items-center gap-2 text-gray-700 dark:text-gray-300"
          >
            <svg className="w-4 h-4 text-primary flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-medium">{topic}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {visible.map((topic, i) => (
        <span
          key={i}
          onClick={onClickTopic ? (e) => { e.preventDefault(); e.stopPropagation(); onClickTopic(topic); } : undefined}
          className={`px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 ${onClickTopic ? 'cursor-pointer hover:bg-primary/10 hover:text-primary transition-colors' : ''}`}
        >
          {topic}
        </span>
      ))}
      {remaining > 0 && (
        <span className="text-xs text-gray-400 self-center">+{remaining} more</span>
      )}
    </div>
  );
};

export default SpeakerTopics;
